import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AddressType } from '../../interfaces/pending-address.interface';

@Component({
  selector: 'app-address-type-tag',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltipModule],
  template: `
    <div class="inline-flex items-center w-fit">
      <span
        *ngIf="type"
        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap w-fit"
        [ngClass]="getTypeClass()"
        [matTooltip]="getTooltipText()"
      >
        <mat-icon class="!w-3.5 !h-3.5 !text-[14px] mr-1">
          {{ getIcon() }}
        </mat-icon>
        <span>{{ type.name }}</span>
      </span>
      <span *ngIf="!type" class="text-gray-400 text-xs whitespace-nowrap">Sin tipo</span>
    </div>
  `,
  styles: [`
    :host {
      display: inline-block;
      width: fit-content;
      min-width: max-content;
    }
  `]
})
export class AddressTypeTagComponent {
  @Input() type: AddressType | undefined;

  getTypeClass(): string {
    if (!this.type) return '';
    
    if (this.type.isDelivery) {
      return 'bg-green-100 text-green-800 border border-green-200';
    }
    
    switch (this.type.type) {
      case 'FAC':
        return 'bg-blue-100 text-blue-800 border border-blue-200';
      case 'CLI':
        return 'bg-purple-100 text-purple-800 border border-purple-200';
      case 'ENT':
        return 'bg-orange-100 text-orange-800 border border-orange-200';
      default:
        return 'bg-gray-100 text-gray-800 border border-gray-200';
    }
  }

  getIcon(): string {
    if (!this.type) return 'location_off';
    
    if (this.type.isDelivery) {
      return 'local_shipping';
    }
    
    switch (this.type.type) {
      case 'FAC':
        return 'receipt_long';
      case 'CLI':
        return 'business';
      case 'ENT':
        return 'home';
      default:
        return 'place';
    }
  }

  getTooltipText(): string {
    if (!this.type) return '';
    
    let tooltip = `Tipo: ${this.type.name}`;
    if (this.type.isDelivery) {
      tooltip += ' (Dirección de entrega)';
    }
    if (this.type.type) {
      tooltip += ` | Código: ${this.type.type}`;
    }
    return tooltip;
  }
}